import AppRoute from "models/AppRoute"

const ProductCategoriesRoute = new AppRoute({
    route: "/app-settings/product-categories",
    navbar: true,
    authRequired: true,
})

export default ProductCategoriesRoute
